// Update Lookbook
export const UPDATE_LOOKBOOK_REQUEST = 'UPDATE_LOOKBOOK_REQUEST';
export const UPDATE_LOOKBOOK_DONE = 'UPDATE_LOOKBOOK_DONE';
export const UPDATE_LOOKBOOK_FAILED = 'UPDATE_LOOKBOOK_FAILED';
export const UPDATE_LOOKBOOK_CLEAR_ERRORS = 'UPDATE_LOOKBOOK_CLEAR_ERRORS';
export const UPDATE_LOOKBOOK_RESET = 'UPDATE_LOOKBOOK_RESET';